module.exports = __webpack_public_path__ + "static/media/86.9e60a760.mp3";